// Staff override for expired booking links.
// NOTE: This is a "friendly" password checked client-side, so it is visible in
// the JS bundle. It's a convenience gate for IMA staff, not real security.
const STAFF_PASSWORD = process.env.REACT_APP_STAFF_UNLOCK_PASSWORD || 'IMAstaff26';
const KEY_PREFIX = 'staffUnlocked:';

export function isStaffUnlocked(bookingId) {
    if (!bookingId) return false;
    try {
        return sessionStorage.getItem(KEY_PREFIX + bookingId) === '1';
    } catch {
        return false;
    }
}

export function tryStaffUnlock(bookingId, password) {
    if ((password || '').trim() !== STAFF_PASSWORD) return false;
    try {
        sessionStorage.setItem(KEY_PREFIX + bookingId, '1');
    } catch {
        /* ignore storage errors */
    }
    return true;
}
